export const environment = {
    production: false,
    serverUrl: 'https://api.alpha-next.fa.rabit.hu',
    googleKey: '1071287441120-94i7kpgtr30fv9u61jf2969i0rt2fltv.apps.googleusercontent.com',
    version: 'FAse 4',
};
